import { HorizontalPositionType } from '@interface/common';

export const LEFT: HorizontalPositionType = 'left';
export const RIGHT: HorizontalPositionType = 'right';
